import { render, staticRenderFns } from "./ContactInformation.vue?vue&type=template&id=5984de1e&scoped=true"
import script from "./ContactInformation.vue?vue&type=script&lang=js"
export * from "./ContactInformation.vue?vue&type=script&lang=js"
import style0 from "./ContactInformation.vue?vue&type=style&index=0&id=5984de1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5984de1e",
  null
  
)

export default component.exports